import React from 'react'
import CustomSelect from 'src/components/CustomComponents/CustomSelect'
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect'

export const BOOK_LEVEL_OPTIONS_UNIVINI = [
	{ label: 'A1', value: 'a1' },
	{ label: 'A2', value: 'a2' },
	{ label: 'B1', value: 'b1' },
	{ label: 'B2', value: 'b2' },
]
export const BOOK_LEVEL_OPTIONS = [
	...BOOK_LEVEL_OPTIONS_UNIVINI,
	{ label: 'Native', value: 'native' },
]

const BOOK_LEVEL_OPTIONS_WITH_ALL = [
	{ label: 'All', value: null },
	...BOOK_LEVEL_OPTIONS,
]

interface BookLevelProps {
	multiple?: boolean
	includeAll?: boolean
	isUnivini?: boolean
	value: string | null | string[]
	onChange: ((value: string | null) => void) | ((value: string[]) => void)
	sx?: any
	placeholder?: string
}

function BookLevel({
	multiple = false,
	includeAll = false,
	isUnivini = false,
	value,
	onChange,
	sx,
	placeholder = 'Level',
}: BookLevelProps) {
	if (isUnivini) {
		return (
			<CustomSelect
				value={!Array.isArray(value) ? value : null}
				data={includeAll ? BOOK_LEVEL_OPTIONS_WITH_ALL : BOOK_LEVEL_OPTIONS_UNIVINI}
				onChange={onChange as (value: string | null) => void}
				placeholder={placeholder}
				sx={sx}
			/>
		)
	}
	if (multiple) {
		return (
			<CustomMultiSelect
				value={Array.isArray(value) ? value : []}
				data={BOOK_LEVEL_OPTIONS}
				onChange={onChange as (value: string[]) => void}
				placeholder={placeholder}
				sx={sx}
			/>
		)
	}

	return (
		<CustomSelect
			value={!Array.isArray(value) ? value : null}
			data={includeAll ? BOOK_LEVEL_OPTIONS_WITH_ALL : BOOK_LEVEL_OPTIONS}
			onChange={onChange as (value: string | null) => void}
			placeholder={placeholder}
			sx={sx}
		/>
	)
}

export default React.memo(BookLevel)
